import React from 'react'

import { useIntl } from 'react-intl'
import EmptyState from '@/components/empty-state'

const ShareLoanEmptyState = () => {
	const { formatMessage } = useIntl()

	return (
		<EmptyState
			iconName="GroupAdd"
			title={formatMessage({
				id: 'share_loan.empty_state.title',
			})}
			description={formatMessage({
				id: 'share_loan.empty_state.description',
			})}
			hint={formatMessage({
				id: 'share_loan.empty_state.hint',
			})}
		/>
	)
}

export default ShareLoanEmptyState
